import _ from 'underscore';

import { globalErrorMsg } from '@bingads-webui-campaign/hotel-common-upsert';
import { validateBidAdjustment } from '../components/utility';

export function getDeviceBasicConfig(i18n, campaignBidStrategyType, showTargetedColumn = true) {
  const columns = _.compact([
    showTargetedColumn ? ({
      key: 'targeted', name: '', fieldName: 'targeted', minWidth: 100, maxWidth: 135, type: 'string', className: 'border-right green-dot', headerClassName: 'target-custom-header',
    }) : null,
    {
      key: 'device', name: i18n.getString(_TL_('Device')), fieldName: 'device', minWidth: 100, maxWidth: 135, type: 'string', className: 'border-right', headerClassName: 'target-custom-header',
    },
  ]);

  const isCommission = campaignBidStrategyType === 'Commission';
  return {
    basicConfig: {
      columns,
      showAddBtn: false,
      showSettingToggle: true,
      titleKey: i18n.getString(_TL_('Device')),
      topicKey: 'pop_BA_CampaignTargets_Device',
      minBid: -90,
      maxBid: 900,
      extraBid: isCommission ? [-100, 0] : [-100],
      onlyExtra: isCommission,
    },
  };
}

export const deviceDefaultSetting = [
  {
    targeted: _TL_('Targeted'),
    device: _TL_('Computer'),
    bidAdjustmentDropdown: 'Increase by',
    bidAdjustmentInput: 0,
  },
  {
    targeted: _TL_('Targeted'),
    device: _TL_('Tablet'),
    bidAdjustmentDropdown: 'Increase by',
    bidAdjustmentInput: 0,
  },
  {
    targeted: _TL_('Targeted'),
    device: _TL_('Smartphone'),
    bidAdjustmentDropdown: 'Increase by',
    bidAdjustmentInput: 0,
  }];

export const isDeviceTargetValid = (device, patchErrMsg = function () { }, campaignBidStrategyType) => {
  let isValid = true;
  const isCommission = campaignBidStrategyType === 'Commission';
  device.filter(item => item.Status !== 'Deleted').forEach((item) => {
    let validateValue = item.bidAdjustmentInput;
    if (item.bidAdjustmentDropdown === 'Decrease by') {
      validateValue = -validateValue;
    }
    if (validateBidAdjustment({
      value: validateValue,
      min: -90,
      max: 900,
      extra: isCommission ? [-100, 0] : [-100],
      onlyExtra: isCommission,
    })) {
      isValid = false;
    }
  });
  if (isValid) {
    patchErrMsg('device', '');
  } else {
    patchErrMsg('device', globalErrorMsg);
  }

  return isValid;
};

